import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import SideNav from './side-nav/SideNav';
import SegmentedTabsLayout from './tabs/SegmentedTabsLayout';
import StickyTabsContainer from '../common/StickyContainer';
const StyledFlexContainer = styled(UIFlex).withConfig({
  displayName: "HeaderLayout__StyledFlexContainer",
  componentId: "sc-2hxq7u-0"
})(["top:-1px;max-width:1330px;margin:auto;margin-top:20px;"]);

const HeaderLayout = ({
  selectedNavItem,
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StickyTabsContainer, {
      children: /*#__PURE__*/_jsx(SegmentedTabsLayout, {
        selectedNavItem: selectedNavItem
      })
    }), /*#__PURE__*/_jsxs(StyledFlexContainer, {
      children: [/*#__PURE__*/_jsx(SideNav, {
        selectedNavItem: selectedNavItem
      }), children]
    })]
  });
};

export default HeaderLayout;